

function PopularArticleCpn({data={}}){

    const {title="",image="",desc="",category=""} = data || {};

    return (
        <>
            <a href="/analysis/best-hardware-wallets/">
                <div className="PopularArticles_cardDiv__gIBGZ">
                    <div className="PopularArticles_upperDiv__mvkSE">
                        <div className="PopularArticles_thumbnailDiv__N1aV4">
                                    <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "block",
                                        overflow: "hidden",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        position: "relative"
                                    }}
                                    >
                                    <span
                                        style={{
                                        boxSizing: "border-box",
                                        display: "block",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: "56.25% 0px 0px"
                                        }}
                                    />
                                    <img
                                        alt="Compare The Top 6 Crypto Hardware Wallets In 2025"
                                        src={image}
                                        decoding="async"
                                        data-nimg="responsive"
                                        className="PopularArticles_image__dU_1R"
                                        style={{
                                        position: "absolute",
                                        inset: 0,
                                        boxSizing: "border-box",
                                        padding: 0,
                                        border: "none",
                                        margin: "auto",
                                        display: "block",
                                        width: 0,
                                        height: 0,
                                        minWidth: "100%",
                                        maxWidth: "100%",
                                        minHeight: "100%",
                                        maxHeight: "100%",
                                        objectFit: "cover"
                                        }}
                                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                    />
                                    <noscript />
                                    </span>
                        </div>
                                
                        <div className="PopularArticles_detailsDiv__5aw14">
                            <div className="PopularArticles_categoryDiv__sJ7Xx">
                                {category}
                            </div>
                                    
                            <div className="PopularArticles_titleDiv__xIxXq">
                                {title}
                            </div>
                                    
                            <div className="PopularArticles_descriptionDiv__N7Lgy">
                                {desc}
                            </div>
                        </div>
                    </div>
                    <div className="PopularArticles_lowerDiv__IwPMs" />
                </div>
            </a>
        </>
    )
}

export default PopularArticleCpn;